<template>
  <div class="error-box blue-grey lighten-5">
    <div class="py-12">
      <div class="text-center">
        <h1 class="error-title red--text text--lighten-1">403</h1>
        <h3 class="text-uppercase error-subtitle white--text">
          Not Authorized
        </h3>
        <p class="text-muted mt-4 mb-4 white--text">
          YOUR LICENSE IS INVALID. PLEASE, CHECK YOUR LICENSE.
        </p>
        <v-btn @click="gotoHandler">Home</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error",
  data: () => ({}),
  mounted() {
    // this.$store.dispatch("signOut");
  },
  methods: {
    gotoHandler: function() {
      window.location.href = process.env.VUE_APP_BASE_URL;
    }
  }
};
</script>

<style lang="scss">
.error-box {
  height: 100%;
  width: 100%;
  position: fixed;
  background-position: top center;
  background-repeat: no-repeat;
  background: url("../../assets/images/background/error-bg.jpg");
}
.error-title {
  font-size: 210px;
  font-weight: 900;
  line-height: 210px;
}

@media (max-width: 991px) {
  .error-title {
    font-size: 120px;
    line-height: 120px;
  }
}

@media (max-width: 767px) {
  .error-title {
    font-size: 40px;
    line-height: 40px;
  }
}
</style>
